module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "dedit"
  }, [_vm._v("Dedicated to Lorraine Dally")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great princes’ favourites their fair leaves spread")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But as the marigold at the sun’s eye;")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And in themselves their pride lies buried,")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For at a frown they in their glory die.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("William Shakespeare, Sonnet 25 (lines 5-8).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777d887a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/FM01.vue
// module id = 60
// module chunks = 0